var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCircleArrowDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#163260"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-383.000000, -378.000000) translate(384.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M8 13L16 19 24 13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleArrowDownBlue);
export default __webpack_public_path__ + "static/media/ic_circle_arrow_down_blue.638725d8fcddc0ebf1eaf5cf4d83fdf7.svg";
export { ForwardRef as ReactComponent };